import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { About } from "@/components/About";
import { Manifesto } from "@/components/Manifesto";
import { Benefits } from "@/components/Benefits";
import { Products } from "@/components/Products";
import { Gallery } from "@/components/Gallery";
import { ArticlesPreview } from "@/components/ArticlesPreview";
import { Testimonials } from "@/components/Testimonials";
import { Marketplace } from "@/components/Marketplace";
import { WhatsAppCTA } from "@/components/WhatsAppCTA";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

export const LandingPage = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <About />
        <Manifesto />
        <Benefits />
        <Products />
        <Gallery />
        <ArticlesPreview />
        <Testimonials />
        <Marketplace />
        <WhatsAppCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};
